import { SortArrows } from "@rio-cloud/rio-uikit";
import classNames from "classnames";

export type ColumnDetails = { [key: string]: number };

export const renderTableHead = (
  column: string,
  label: string,
  sortByColumn: string,
  handleSortChange: () => void,
) => {
  const tableHeadClassNames = classNames("user-select-none", "sort-column");

  return (
    <th
      key={column}
      className={tableHeadClassNames}
      onClick={handleSortChange}
      data-field={column}
      data-sortby={column}
      title={label}
      style={{ textAlign: column === "rio" ? "center" : undefined }}
    >
      <span>
        {sortByColumn === column ? <SortArrows /> : <SortArrows />}
        <span>{label}</span>
      </span>
    </th>
  );
};

export const renderTableCaption = (column: string, columnDetails: ColumnDetails) => {
  const width = columnDetails?.width || columnDetails?.defaultWidth || 100;
  
  return <col key={column} style={{ minWidth: width, width: width }} />;
};